module.exports = __webpack_public_path__ + "img/refresh-error.f2fa575e.svg";